import ModalSecteurController from './modal.secteur.controller';
import Template from './modal.secteur.html';
export default {
	bindings: {
		resolve: '<',
		close: '&',
		dismiss: '&'
	},
	template: Template,
	controller: ModalSecteurController
};
